import gql from 'graphql-tag';

export const respondToEventLiveFeedMutation = gql`
  mutation respondToEventLiveFeed($approvalId: String!, $approve: Boolean!, $rejectionReason: String) {
    respondToEventLiveFeed(approvalId: $approvalId, approve: $approve, rejectionReason: $rejectionReason)
  }
`;
